export const yihaiRoutes = [{
    path: '/yiHai',
    component: () => import('./yiHai'),
    meta: {
        crumbName: '艺海颉英'
    },
    children: [
        {
            path: 'expertTeam',
            name: '专家团队',
            component: () => import('../expertTeam'),
            meta: {
                //标明是否需要登录后才能访问
                auth:false,
            }
        }, {
            path: 'studentList',
            name: '明日之星',
            component: () => import('../studentList'),
            meta: {
                //标明是否需要登录后才能访问
                auth:false,
            }
        }, {
            path: 'teacher',
            name: '名师详情',
            component: () => import('../teacher'),
            meta: {
                //标明是否需要登录后才能访问
                auth:false
            }
        },{
            path: 'student',
            name: '明日之星详情',
            component: () => import('../student'),
            meta: {
                //标明是否需要登录后才能访问
                auth:false
            }
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/pages/yiHai/router/yihai.routes.js